import { prompt } from '@kuaizhan/kui';
export var passportOffline = function passportOffline() {
  return {
    type: 'passport.offline'
  };
};
export var passportOnline = function passportOnline(_ref) {
  var userName = _ref.userName,
      verificationStatus = _ref.verificationStatus,
      verificationType = _ref.verificationType,
      inWhiteList = _ref.inWhiteList;
  return {
    userName: userName,
    verificationStatus: verificationStatus,
    verificationType: verificationType,
    inWhiteList: inWhiteList,
    type: 'passport.online'
  };
};
export var passportStatus = function passportStatus(ds) {
  return function (dispatch) {
    ds.resolve('v2/user.get-info').then(function (res) {
      dispatch(passportOnline({
        userName: res.body.data.username,
        verificationType: res.body.data.verification_type,
        verificationStatus: res.body.data.verification_status,
        inWhiteList: res.body.data.in_white_list
      }));
    }).catch(function (e) {
      if (e.code === 6 || e.code === 3) {
        dispatch(passportOffline());
      } else {
        console.log(e.message);
      }
    });
  };
}; // 账号登录操作

export var passportLogin = function passportLogin(ds, formData) {
  return function (dispatch) {
    // 校验参数
    if (!formData.username) {
      prompt.alert('用户名不能为空');
      return;
    }

    if (!formData.password) {
      prompt.alert('登录密码不能为空');
      return;
    }

    if (!formData.vcode) {
      prompt.alert('验证码不能为空');
      return;
    }

    ds.resolve('v2/passport.login', {
      body: formData
    }).then(function (res) {
      if (res.status === 200) {
        var data = res.body;

        if (data.ret === 0) {
          dispatch(passportStatus(ds));
        } else {
          prompt.alert(data.msg);
        }
      }
    }).catch(function (e) {
      prompt.alert(e.message);
    });
  };
};